<template>
    <div
        :class="[
            'input-group',
            'date',
            'bs-date-picker',
            typeClass
        ]"
    >
        <BootstrapDatepickerSimple
            ref="wrappedPicker"
            wrapped="true"
            v-bind="$attrs"
            :type="type"
            :raw-value="rawValue"
            @input="changed"
        />
        <span class="input-group-addon"><span class="glyphicon glyphicon-calendar" /></span>
    </div>
</template>

<script>
'use strict';

/* eslint vue/require-prop-types: "off" */

import BootstrapDatepickerSimple, { typeClasses } from './bootstrap-datepicker-simple.vue';

export default {
    components: {
        BootstrapDatepickerSimple,
    },
    inheritAttrs: false,
    model: {
        prop: 'rawValue',
    },
    props: ['type', 'rawValue'],
    data() {
        const typeClass = typeClasses[this.type];
        return {
            typeClass: typeClass.clazz,
        };
    },
    mounted() {
        const typeClass = typeClasses[this.type];
        $(this.$el).datetimepicker(Object.assign({ language: 'it' }, typeClass.options));
        $(this.$el).on('dp.change auto-changed', () => {
            this.$refs.wrappedPicker.changed();
        });
    },
    beforeDestroy() {
        this.getDatePicker().destroy();
    },
    methods: {
        getDatePicker() {
            return $(this.$el).data('DateTimePicker');
        },
        changed(value) {
            this.$emit('input', value);
        },
    },
};
</script>
